var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarginBottomXs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_109)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    transform: "translate(196 97.9999) rotate(180)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 60.9999,
    width: 180,
    height: 70,
    rx: 5,
    transform: "rotate(180 188 60.9999)",
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 60.9999,
    width: 180,
    height: 70,
    rx: 5,
    transform: "rotate(180 188 60.9999)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6464 79.3535C97.8417 79.5488 98.1583 79.5488 98.3536 79.3535L101.536 76.1715C101.731 75.9762 101.731 75.6597 101.536 75.4644C101.34 75.2691 101.024 75.2691 100.828 75.4644L98 78.2928L95.1716 75.4644C94.9763 75.2691 94.6597 75.2691 94.4645 75.4644C94.2692 75.6597 94.2692 75.9762 94.4645 76.1715L97.6464 79.3535ZM98.3536 68.6464C98.1583 68.4511 97.8417 68.4511 97.6464 68.6464L94.4645 71.8284C94.2692 72.0236 94.2692 72.3402 94.4645 72.5355C94.6597 72.7307 94.9763 72.7307 95.1716 72.5355L98 69.707L100.828 72.5355C101.024 72.7307 101.34 72.7307 101.536 72.5355C101.731 72.3402 101.731 72.0236 101.536 71.8284L98.3536 68.6464ZM98.5 78.9999L98.5 68.9999L97.5 68.9999L97.5 78.9999L98.5 78.9999Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 144,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 144)",
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 144,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 144)",
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white",
    transform: "translate(196 97.9999) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginBottomXs);
export default __webpack_public_path__ + "static/media/margin_bottom_xs.c78dd14f52202bcbc00a3aa72ddb57a1.svg";
export { ForwardRef as ReactComponent };